export default __webpack_public_path__ + "static/media/amarona-maher-zain.0923a046.mp3";